import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { getPopularMovies, formatViews } from "@/utils/movies";

export default function PopularSection() {
  const popular = getPopularMovies(8);

  return (
    <section className="px-4 md:px-10 py-6 md:py-10">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          title="热门榜"
          subtitle="根据浏览量与人气综合排序"
          moreTo="/category?sort=hot"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {popular.map((movie, i) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-4 p-3 bg-background-100 border border-background-200/60 rounded-lg hover:border-accent-500/60 transition-colors"
            >
              <span
                className={`w-8 shrink-0 text-center font-heading font-black text-xl md:text-2xl ${
                  i < 3 ? "text-accent-500" : "text-foreground-600"
                }`}
              >
                {i + 1}
              </span>
              <span className="w-14 h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={movie.poster}
                  alt={`${movie.title} 封面`}
                  title={`${movie.title} 影视内容`}
                  className="w-full h-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm md:text-base font-semibold text-foreground-50 truncate group-hover:text-accent-500 transition-colors">
                  {movie.title}
                </span>
                <span className="block text-xs text-foreground-500 mt-1 truncate">
                  {movie.genres.slice(0, 3).join(" / ")}
                </span>
                <span className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500" />
                    {movie.rating.toFixed(1)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {formatViews(movie.views)}
                  </span>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}